<ui-icon [faName]="icon()" [faStyle]="iconStyle()"></ui-icon>
<h6>{{ title() }}</h6>
